import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import { readTaskCaseDetailsTabFromSearchParams } from '../../pages/task-case/taskCaseDetailsAccess';
import type { TaskCaseDetailsReturnState } from '../../pages/task-case/taskCaseDetailsReturnNavigation';

type TaskCaseDetailsBreadcrumbProps = {
  returnState: TaskCaseDetailsReturnState;
};

export function TaskCaseDetailsBreadcrumb({ returnState }: TaskCaseDetailsBreadcrumbProps) {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const viewMode = searchParams.get('mode') === 'view';
  const detailsTab = readTaskCaseDetailsTabFromSearchParams(searchParams, viewMode);
  const leafLabelKey =
    detailsTab === 'cu' ? 'tasks.details.tabCaseUpdate' : 'tasks.details.breadcrumb';

  return (
    <div className="bc">
      <Link to={returnState.returnTo}>{t(returnState.returnLabelKey)}</Link>
      <span className="bc-sep">/</span>
      {t(leafLabelKey)}
    </div>
  );
}
